export const RECALCULATED_CARD_TITLE = 'Recalculated, with no pending change behind them';
